var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.52 28.16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.76 0h-.59a16.27 16.27 0 00-2.44.24A16.24 16.24 0 003 5.49 12 12 0 001.85 7 11.47 11.47 0 000 13.24a12.5 12.5 0 005.64 10.15 15.48 15.48 0 01-1.27 2.7c-.24.4-.49.79-.77 1.17a.57.57 0 00.55.89 14.88 14.88 0 001.48-.29 17.28 17.28 0 005-2.1 18.27 18.27 0 005.13.72c8.7 0 15.76-5.93 15.76-13.24S24.46 0 15.76 0zm0 24.48a16.22 16.22 0 01-3-.27c-.44-.08-.87-.17-1.29-.29a2.79 2.79 0 00-2.15.3c-.38.22-.77.43-1.17.62s-.76.35-1.15.5c.13-.29.26-.59.37-.89s.31-.87.44-1.32a.63.63 0 000-.27.76.76 0 00-.15-.41v-.09a1.3 1.3 0 00-.18-.15 12.09 12.09 0 01-1.22-.86A10.32 10.32 0 012 13.24a9.4 9.4 0 011.26-4.68 9.76 9.76 0 011.12-1.62 14.42 14.42 0 019.83-4.86A13.18 13.18 0 0115.76 2h.78c7.23.33 13 5.23 13 11.22-.02 6.22-6.19 11.26-13.78 11.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.76 11.4a1.84 1.84 0 101.84 1.84 1.84 1.84 0 00-1.84-1.84zM8.76 11.4a1.84 1.84 0 101.84 1.84 1.84 1.84 0 00-1.84-1.84zM22.76 11.4a1.84 1.84 0 101.84 1.84 1.84 1.84 0 00-1.84-1.84z"
  })))));
}

export default SvgMessage;